import { styled } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';

export const StyledResourceDialogActions = styled(DialogActions)(() => ({
  justifyContent: 'center',
}));
